<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md12>
        <v-card flat class="border-container">
          <v-card-text>
            <strong>INFORMACIÓN DEL COLEGIO</strong>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <span>Nombre del colegio</span>
                <v-text-field
                  class="border-container"
                  hide-details
                  solo
                  flat
                  rounded
                  required
                  v-model="$v.formCollege.nameCollege.$model"
                />

                <span
                  class="error-pass"
                  v-if="submitted && !$v.formCollege.nameCollege.required"
                  >Nombre del colegio es obligatorio</span
                >
              </v-flex>
            </v-layout>
            <div class="mt-3">
              <strong>INFORMACIÓN DEL ADMINISTRADOR DEL COLEGIO</strong>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <span>Nombre del Administrador</span>
                  <v-text-field
                    class="border-container"
                    hide-details
                    solo
                    required
                    flat
                    dense
                    v-model="$v.formCollege.nameAdmin.$model"
                  />

                  <span
                    class="error-pass"
                    v-if="submitted && !$v.formCollege.nameAdmin.required"
                    >Nombre del colegio es obligatorio</span
                  >
                </v-flex>
                <v-flex xs12 sm6>
                  <span>Apellido del Administrador</span>

                  <v-text-field
                    class="border-container"
                    hide-details
                    solo
                    required
                    flat
                    dense
                    v-model="$v.formCollege.lastNameAdmin.$model"
                  />

                  <span
                    class="error-pass"
                    v-if="submitted && !$v.formCollege.lastNameAdmin.required"
                    >Nombre del colegio es obligatorio</span
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <span>Correo electrónico del Administrador</span>
                  <v-text-field
                    class="border-container"
                    hide-details
                    solo
                    flat
                    required
                    dense
                    v-model="$v.formCollege.emailAdmin.$model"
                  />

                  <div
                    v-if="submitted && $v.formCollege.emailAdmin.$error"
                    class="error-pass"
                  >
                    <span v-if="!$v.formCollege.emailAdmin.required"
                      >Email is required</span
                    >
                    <span v-if="!$v.formCollege.emailAdmin.email"
                      >Email is invalid</span
                    >
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <span>Contraseña</span>
                  <v-text-field
                    class="border-container"
                    hide-details
                    solo
                    flat
                    dense
                    required
                    v-model="$v.formCollege.passwordAdmin.$model"
                  />

                  <div
                    v-if="submitted && $v.formCollege.passwordAdmin.$error"
                    class="error-pass"
                  >
                    <span v-if="!$v.formCollege.passwordAdmin.required"
                      >Password is required</span
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <span>Confirmar contraseña</span>

                  <v-text-field
                    class="border-container"
                    hide-details
                    solo
                    flat
                    required
                    dense
                    v-model="$v.formCollege.confirmPassword.$model"
                  />
                  <div
                    v-if="submitted && $v.formCollege.confirmPassword.$error"
                    class="error-pass"
                  >
                    <span v-if="!$v.formCollege.confirmPassword.required"
                      >Confirm Password is required</span
                    >
                    <span
                      v-else-if="!$v.formCollege.confirmPassword.sameAsPassword"
                      >Passwords must match</span
                    >
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
          <v-divider></v-divider>

          <div class="container--btn mt-2 mb-2">
            <v-spacer></v-spacer>
            <v-btn class="custom-border" depressed outline>Cancelar</v-btn>
            <v-btn class="custom-border" @click="submit()" depressed outline
              >Guardar</v-btn
            >
          </div>
        </v-card>
      </v-flex>
    </v-layout>
     <Success
            :value="success.modal"
            title=""
            description="!Colegio creado con éxito!"
            v-on:desition="successCreate"
          />
  </div>
</template>

<script>
import { required, sameAs, email } from 'vuelidate/lib/validators'
import Success from '../components/Success.vue'

export default {
  components:{
    Success
  },
  validations: {
    formCollege: {
      nameCollege: { required },
      nameAdmin: { required },
      lastNameAdmin: { required },
      emailAdmin: { required, email },
      passwordAdmin: { required },
      confirmPassword: { required, sameAsPassword: sameAs('passwordAdmin') },
    },
  },
  data() {
    return {
      success:{
        modal:false
      },
      submitted: false,
      formCollege: {
        nameCollege: 'prueba',
        nameAdmin: 'Brayan',
        lastNameAdmin: 'Sandoval',
        emailAdmin: 'brayan@kiritek.com',
        passwordAdmin: '7861127450',
        confirmPassword: '7861127450',
      },
    }
  },
  methods: {
     successCreate(){
      this.success.modal = true;
      setTimeout(() =>{
      this.$router.push({
              name: "Colleges",
            });
      },2000)
    },
    submit() {
      console.log('hola')
      this.submitted = true
      this.$v.formCollege.$touch()
      if (this.$v.formCollege.$invalid) {
        return
      }
      let body = {
        name: this.formCollege.nameCollege,
        type: 1,
        licenses: 666,
        administrator: {
          firstName: this.formCollege.nameAdmin,
          lastName: this.formCollege.lastNameAdmin,
          email: this.formCollege.emailAdmin,
          password: this.formCollege.passwordAdmin,
        },
      }
      this.$store
        .dispatch('colleges/createCollege', body)
        .then(res => {
          this.successCreate();
        })
        .catch(e => {
          console.log(e)
        })
        .finally(f => console.log(f, 'finish'))
    },
  },
  computed: {
    nameCollege() {
      if (
        !this.$v.formCollege.nameCollege.$dirty ||
        this.formCollege.nameCollege
      )
        return ''
      return 'Nombre de colegio obligatorio'
    },
    nameAdmin() {
      if (!this.$v.formCollege.nameAdmin.$dirty || this.formCollege.nameAdmin)
        return ''
      return 'Nombre de administrador obligatorio'
    },
    lastNameAdmin() {
      if (
        !this.$v.formCollege.lastNameAdmin.$dirty ||
        this.formCollege.lastNameAdmin
      )
        return ''
      return 'Apellido de administardor obligatorio'
    },
    emailAdmin() {
      if (!this.$v.formCollege.emailAdmin.$dirty) return ''
      if (!this.formCollege.emailAdmin) {
        return 'Correo electrónico obligatorio'
      }
      var emailReg = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])$/i
      if (!emailReg.test(this.formCollege.emailAdmin)) {
        return 'Correo electrónico incorrecto'
      }
      return []
    },
    passwordAdmin() {
      if (
        !this.$v.formCollege.passwordAdmin.$dirty ||
        this.formCollege.passwordAdmin
      )
        return ''
      return 'Contraseña es obligatorio'
    },
    confirmPassword() {
      if (
        !this.$v.formCollege.confirmPassword.$dirty ||
        this.formCollege.confirmPassword
      )
        return ''
      return 'Confirmar Contraseña es obligatorio'
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
  padding: 0;
}
.container--btn {
  display: flex;
  justify-content: flex-end;
}
.custom-border {
  border-radius: 0.5rem;
  border-color: #ccc !important;
}
.input-height {
  height: 45px;
  padding: 0;
}
::v-deep .v-input__slot {
  min-height: unset;
  height: 35px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;

  padding: 0;
}
.error-pass {
  color: #f44336;
}
</style>
